import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getObjectFromLocalStore, removeLocalStore } from "../utils/localStore";
import { resetLoginState, resetLogoutState, setFCMToken } from "app/redux";
import { clearSessionStore } from "app/utils/sessionStore";
import { AutoLogoutProps, USERTYPE } from "app/utils/types";

const SESSION_IDLE_MINUTES = process.env.REACT_APP_LOGOUT_IDLE_MINUTES;
const SESSION_IDLE_MINUTES_CONTACT = process.env.REACT_APP_LOGOUT_IDLE_MINUTES_CONTACT;

const AutoLogoutTimer = ({ ComposedClass }: any) => {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const userAccess = getObjectFromLocalStore("useraccess");

  const handleOnIdle = () => {
    removeLocalStore("useraccess");
    removeLocalStore("assistantAgentUserAccess");
    clearSessionStore();
    dispatch(resetLogoutState());
    dispatch(resetLoginState());
    dispatch(setFCMToken(false));
    nav("/", { replace: true });
  };

  useIdleTimer({
    timeout:
      1000 *
      60 *
      Number(
        userAccess?.userType === USERTYPE.CONTACT
          ? SESSION_IDLE_MINUTES_CONTACT
          : SESSION_IDLE_MINUTES,
      ),
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return <ComposedClass />;
};

function areEqual(prevProps: Readonly<AutoLogoutProps>, nextProps: Readonly<AutoLogoutProps>) {
  if (prevProps?.location?.pathname === nextProps?.location?.pathname) {
    return true;
  }
  return false;
  /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */
}

export default React.memo(AutoLogoutTimer, areEqual);
